import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import style from './EuleriagymBalanceEvaluationResults.module.sass';
import Select from '../Select/Select';
import EuleriagymBalanceEvaluationResult from './EuleriagymBalanceEvaluationResult/EuleriagymBalanceEvaluationResult';

function EuleriagymBalanceEvaluationResults(props) {
  const {
    color,
    exerciseName,
    results,
    sideChooser
  } = props;

  const [selectedResult, setSelectedResult] = useState({});

  useEffect(() => {
    setSelectedResult(optionsForSelect()[0]);
  }, [])

  const optionsForSelect = () => {
    return results.map((result, index) => {
      return {
        value: result.modality,
        label: `${index + 1}. ${result.modality}`,
        key: index,
        result: result
      }
    })
  }

  return (
    <div>
      <div className={style.resultSelectionTile}>
        <div className={style.exerciseName} style={{color: color}}>{exerciseName}</div>
        <div className={style.resultsSelect}>
          <Select
            options={optionsForSelect()}
            searchable={false}
            selectedOption={selectedResult.label}
            setOption={setSelectedResult}
          />
        </div>
      </div>
      {selectedResult.result &&
        <div className={style.resultContainer}>
          <EuleriagymBalanceEvaluationResult
            anteroPosteriorChart={selectedResult.result.anteroPosteriorChart}
            bidimensionalChart={selectedResult.result.bidimensionalChart}
            duration={selectedResult.result.duration}
            maxDeviation={selectedResult.result.maxDeviation}
            midLateralChart={selectedResult.result.midLateralChart}
            percentages={selectedResult.result.percentages}
            rms={selectedResult.result.rms}
            sideChooser={sideChooser}
            sides={selectedResult.result.sides}
            sway={selectedResult.result.sway}
          />
        </div>
      }
    </div>
  )
}

EuleriagymBalanceEvaluationResults.propTypes = {
  color: PropTypes.string,
  exerciseName: PropTypes.string,
  results: PropTypes.array,
  sideChooser: PropTypes.object
}

export default EuleriagymBalanceEvaluationResults;